$(function () {
    $('[data-popup-modal]').each(function () {
        init(this);
    });

    function init(el) {
        $(el).on('click', function(ev) {
            ev.preventDefault();
            show(el.dataset.title, el.dataset.description, el.dataset.phone, el.dataset.key);
        });
    }

    function show(title, description, phone, key) {
        var row = [
            '<div class="popup-modal">',
                '<div class="popup-modal__content">',
                    '<div class="popup-modal__title">', title, '</div>',
                    '<div class="popup-modal__description">', description, '</div>',
                    '<div class="popup-modal__label">Telefone</div>',
                    '<div class="popup-modal__value">', phone, '</div>',
                    '<div class="popup-modal__label">Chave</div>',
                    '<div class="popup-modal__value">', key, '</div>',
                    '<div class="popup-modal__close" data-close>OK</div>',
                '</div>',
            '</div>'
        ];

        $popup = $(jQuery.trim(row.join('')));
        $('body').append($popup);

        $popup.on('click', '[data-close]', function() {
            $popup.remove();
        });
    }
});